export const phoneLengthMap = {
    '+1': 10, '+7': 10, '+20': 10, '+27': 9, '+30': 10,
    '+31': 9, '+32': 9, '+33': 9, '+34': 9, '+36': 9,
    '+39': 10, '+40': 10, '+41': 9, '+43': 10, '+44': 10,
    '+45': 8, '+46': 9, '+47': 8, '+48': 9, '+49': 11,
    '+51': 9, '+52': 10, '+53': 8, '+54': 10, '+55': 11,
    '+56': 9, '+57': 10, '+58': 10, '+60': 9, '+61': 9,
    '+62': 11, '+63': 10, '+64': 9, '+65': 8, '+66': 9,
    '+81': 10, '+82': 10, '+84': 10, '+86': 11, '+90': 10,
    '+91': 10, '+92': 10, '+93': 9, '+94': 9, '+95': 9,
    '+98': 10,
    '+212': 9, '+213': 9, '+216': 8, '+218': 9, '+220': 7,
    '+221': 9, '+222': 8, '+223': 8, '+224': 9, '+225': 10,
    '+226': 8, '+227': 8, '+228': 8, '+229': 8, '+230': 8,
    '+231': 8, '+232': 8, '+233': 9, '+234': 10, '+235': 8,
    '+236': 8, '+237': 9, '+238': 7, '+239': 7, '+240': 9,
    '+241': 7, '+242': 9, '+243': 9, '+244': 9, '+245': 7,
    '+246': 7, '+247': 4, '+248': 7, '+249': 9, '+250': 9,
    '+251': 9, '+252': 8, '+253': 8, '+254': 9, '+255': 9,
    '+256': 9, '+257': 8, '+258': 9, '+260': 9, '+261': 9,
    '+262': 9, '+263': 9, '+264': 9, '+265': 9, '+266': 8,
    '+267': 8, '+268': 8, '+269': 7, '+290': 4, '+291': 7,
    '+297': 7, '+298': 6, '+299': 6, '+350': 8, '+351': 9,
    '+352': 9, '+353': 9, '+354': 7, '+355': 9, '+356': 8,
    '+357': 8, '+358': 9, '+359': 9, '+370': 8, '+371': 8,
    '+372': 8, '+373': 8, '+374': 8, '+375': 9, '+376': 6,
    '+377': 8, '+378': 10, '+380': 9, '+381': 9, '+382': 8,
    '+385': 9, '+386': 8, '+387': 8, '+389': 8, '+420': 9,
    '+421': 9, '+423': 7, '+500': 5, '+501': 7, '+502': 8,
    '+503': 8, '+504': 8, '+505': 8, '+506': 8, '+507': 8,
    '+508': 6, '+509': 8, '+590': 9, '+591': 8, '+592': 7,
    '+593': 9, '+595': 9, '+596': 9, '+597': 7, '+598': 8,
    '+599': 7, '+670': 8, '+672': 6, '+673': 7, '+674': 7,
    '+675': 8, '+676': 7, '+677': 7, '+678': 7, '+679': 7,
    '+680': 7, '+681': 6, '+682': 5, '+683': 4, '+685': 7,
    '+686': 8, '+687': 6, '+688': 5, '+689': 8, '+690': 4,
    '+691': 7, '+692': 7, '+850': 10, '+852': 8, '+853': 8,
    '+855': 9, '+856': 10, '+880': 10, '+886': 9, '+960': 7,
    '+961': 8, '+962': 9, '+963': 9, '+964': 10, '+965': 8,
    '+966': 9, '+967': 9, '+968': 8, '+970': 9, '+971': 9,
    '+972': 9, '+973': 8, '+974': 8, '+975': 8, '+976': 8,
    '+977': 10, '+992': 9, '+993': 8, '+994': 9, '+995': 9,
    '+996': 9, '+998': 9,
};

export const phoneMasks = {
    '1': '(999) 999-9999',
    '1-242': '(999) 999-9999',
    '1-246': '(999) 999-9999',
    '1-345': '(999) 999-9999',
    '1-876': '(999) 999-9999',
    '501': '999-9999',
    '502': '9999-9999',
    '503': '9999-9999',
    '504': '9999-9999',
    '505': '9999-9999',
    '506': '9999-9999',
    '507': '9999-9999',
    '44': '9999 999999',
    '49': '9999 9999999',
    '33': '99 99 99 99 99',
    '39': '999 999 9999',
    '34': '999 999 999',
    '31': '99 999 9999',
    '41': '99 999 99 99',
    '91': '99999-99999',
    '92': '9999-9999999',
    '94': '99 999 9999',
    '971': '99 999 9999',
    '966': '99 999 9999',
    '65': '9999 9999',
    '60': '99-999 9999',
    '81': '99-9999-9999',
    '86': '999 9999 9999',
    '61': '9999 999 999',
    '64': '99 999 9999',
};

export function resolvePhoneLength(countryCodeValue, countryCodeList) {
    if (!countryCodeValue || !countryCodeList?.length) {
        return 10;
    }

    const selectedCountry = countryCodeList.find(c => c.value === countryCodeValue);
    if (!selectedCountry?.text) {
        return 10;
    }

    let dialCode = selectedCountry.text.trim().split(' ')[0];
    if (dialCode.includes('-')) {
        const parts = dialCode.split('-');
        const subCode = '+' + parts[1];
        dialCode = phoneLengthMap[subCode]
            ? subCode
            : '+' + parts[0].replace('+', '');
    }

    return phoneLengthMap[dialCode] || 10;
}

export function resolvePhoneMask(countryCodeValue, countryCodeList, phoneLength) {
    if (!countryCodeValue || !countryCodeList?.length) {
        return '(999) 999-9999';
    }

    const selected = countryCodeList.find(c => c.value === countryCodeValue);
    if (!selected?.text) {
        return '(999) 999-9999';
    }

    const code = selected.text.trim().split(' ')[0].replace('+', '');
    return phoneMasks[code] || '9'.repeat(phoneLength || 10);
}

export function findDefaultUsCountryCode(countryCodeList) {
    if (!Array.isArray(countryCodeList)) {
        return null;
    }

    return countryCodeList.find(item =>
        item.text?.includes('US') && item.text?.includes('+1')
    ) || null;
}

export function resolvePhoneFieldError(errors) {
    if (!errors) {
        return '';
    }

    return errors.phone || errors.countryCode || '';
}
